import type {RootStoreModel} from "@stores/RootStore";
import type {DataSourceManager} from "@stores/dataSources/DataSourceManager";

import {PAGES} from "@stores/ViewStore";


export const getPageTitle = (dsManager: DataSourceManager | undefined, rootStore: RootStoreModel) => {
    return `${getPageTitleInner(dsManager, rootStore)} | Logycore`;
}

const getPageTitleInner = (dsManager: DataSourceManager | undefined, rootStore: RootStoreModel) => {
    const view = rootStore.view;
    const client = dsManager?.clientAR.row;
    const activeWorkspace = rootStore.view.workspace;
    switch (view.page) {
        case PAGES.DOC_EDIT:
            const selectedItem = activeWorkspace!.selected;
            if (!selectedItem) {
                return client ? client.slug : 'Logycore';
            }
            return selectedItem.name;
        case PAGES.KNOWLEDGE_BASE:
        default:
            return client ? client.slug : 'Logycore';
    }
}
